import React from "react";
import { Link } from "react-router-dom";
import { Play } from "lucide-react";
import "../../styles/sbdrk-logo-font.css";
import { openWeaveBookingInNewTab, WEAVE_BOOKING_URL } from "../../lib/weaveBooking";

const Hero = () => {
  return (
    <section id="home" className="relative bg-[#FBF8F1] overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1588776814546-daab30f310ce')",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#FBF8F1] via-[#FBF8F1]/70 to-[#F7F2E8]/40" />
      <div
        className="absolute inset-0 opacity-30"
        style={{
          backgroundImage:
            "radial-gradient(circle at 30% 50%, rgba(200,168,120,0.18), transparent 50%)",
        }}
      />

      <div className="relative max-w-7xl mx-auto px-6 py-10  grid lg:grid-cols-2 gap-10 items-center">
        <div>
          <p className="font-script text-4xl md:text-5xl gold-gradient-text mb-3 p-2">
            Welcome to
          </p>
          <h1 className="inline-flex flex-wrap md:flex-nowrap items-baseline gap-[0.16em] md:gap-[0.22em] leading-tight tracking-wider sbdrk-logo-lockup">
            <span className="gold-gradient-text sbdrk-logo-left !text-[clamp(1.8rem,8vw,4.6rem)] p-4">Galleria Dental</span>
            <span className="sbdrk-logo-right !text-[clamp(1.2rem,4.4vw,2.8rem)] !leading-none text-[#047857]">spa</span>
          </h1>
          <div className="flex items-center gap-3 my-7">
            <span className="h-px w-12 bg-gradient-to-r from-transparent to-[#B79A68]" />
            <span className="font-script text-2xl gold-gradient-text">
              your smile, our passion
            </span>
            <span className="h-px w-12 bg-gradient-to-l from-transparent to-[#B79A68]" />
          </div>
          <p className="text-[#4E5750] max-w-xl leading-relaxed text-base md:text-lg">
            We see our exclusive dental practice as an extension of your home, a
            place where you always feel welcome and comfortable. It’s a place where 
            you can come to relax, heal, rejuvenate, and walk out with a healthy and 
            beautiful smile feeling great about yourself and life in general.
          </p>
          <div className="flex flex-wrap gap-4 mt-8">
            <a
              href={WEAVE_BOOKING_URL}
              onClick={openWeaveBookingInNewTab}
              className="bg-gradient-to-b from-[#B79A68] to-[#8D7448] hover:from-[#C8AE7F] hover:to-[#A18354] text-[#ffffff] px-7 py-3 uppercase text-[11px] tracking-[0.25em] font-semibold font-cinzel transition-all"
            >
              Book a Consult
            </a>
            <Link
              to="/dental-services"
              className="border border-[#B79A68] text-[#7D6A42] hover:bg-[#B79A68] hover:text-[#ffffff] px-7 py-3 uppercase text-[11px] tracking-[0.25em] font-semibold font-cinzel transition-all"
            >
              Our Dental Services
            </Link>
          </div>
        </div>

        <div className="relative hidden lg:flex justify-center items-center">
          <div className="absolute w-[420px] h-[420px] rounded-full border border-[#B79A68]/40" />
          <div className="absolute w-[460px] h-[460px] rounded-full border border-[#B79A68]/20" />
          <div className="relative w-[380px] h-[380px] rounded-full overflow-hidden shadow-[0_0_60px_-10px_rgba(200,168,120,0.4)]">
            <video
              src="https://galleria-dental-media.s3.eu-north-1.amazonaws.com/uploads/testimonials/8bdce0df-5e4c-4aa6-b458-fe1351b40c6d.mp4"
              autoPlay
              muted
              loop
              playsInline
              className="w-full h-full object-cover"
            />
            <button
              aria-label="Play intro video"
              className="absolute inset-0 flex items-center justify-center group"
            >
              {/* <span className="w-16 h-16 rounded-full bg-[#c8a878] text-[#ffffff] flex items-center justify-center shadow-xl group-hover:scale-110 transition-transform">
                <Play size={22} fill="currentColor" />
              </span> */}
            </button>
          </div>
        </div>
      </div>

      <div className="relative h-px bg-gradient-to-r from-transparent via-[#B79A68] to-transparent" />
    </section>
  );
};

export default Hero;
